import { ReactNode, useEffect, useRef, useState } from "react";
import { motion } from "motion/react";

export function Scale({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement | null>(null)

  const [show, setShow] = useState(false)

  useEffect(() => {
    setTimeout(() => {
      setShow(true)
    }, 200);
  }, [])

  if (!show) {
    return null
  }

  return (<div ref={ref}>
    <motion.div
      initial={{ opacity: 0, scale: 0.1 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, root: ref, amount: 0.2 }}
      transition={{ duration: 1, ease: "anticipate" }}
      className="ani-events"
    >
      {children}
    </motion.div>
  </div>
  );
}
